import {useMutation, useQueryClient} from 'react-query';
import {AddBusinessType} from 'models';
import useAxios from 'config/RequestInterceptor';

export const useAddBusiness = () => {
    const queryClient = useQueryClient();

    const addBusiness = async (values: AddBusinessType) => {
        return await useAxios.post('/wp-json/jwt-auth/v1/business', values);
    };
    return useMutation('add-new-business', {
        mutationFn: addBusiness,
        onSuccess: () => {
            queryClient.invalidateQueries('get-business-by-user').catch();
        },
    });
};

export default useAddBusiness;
